import React, { useContext, useMemo } from "react";
import { trpc } from "../../../utils/trpc";
import { ArticleContext } from "../WithArticle/ArticleContext";
import { BookmarkContext } from "./BookmarkContext";

export const ArticleBookmarkProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { articleSlug } = useContext(ArticleContext);

  const { data } = trpc.getBookmarksByArticle.useQuery(
    { articleSlug: articleSlug! },
    { enabled: !!articleSlug },
  );

  const value = useMemo(() => {
    return {
      bookmarksByPublication: data,
    };
  }, [data]);

  return (
    <BookmarkContext.Provider value={value}>
      {children}
    </BookmarkContext.Provider>
  );
};
